import { DateInput, Select, TextAreaInput, TextInput } from '@octano/global-ui';
import { useFormContext } from 'react-hook-form';
import { Col, Row } from 'reactstrap';
import { useValidations } from '../../../../../hooks/useValidations';
import useTexts from '../hooks/useTexts';
import { CreateSessionForm } from './FormCreate';
import RemoteSearchField from './RemoteSearchField';
import { useSessionFormLoaderData } from '../hooks/SessionFormLoader';
import { useMemo } from 'react';
import dayjs from 'dayjs';

const FormFields = ({ disabled }: { disabled?: boolean }) => {
  const texts = useTexts();
  const {
    periods: periodOptions,
    schools: schoolOptions,
    years: yearsOptions,
  } = useSessionFormLoaderData();

  const { msgValidations } = useValidations();

  const { control, watch } = useFormContext<CreateSessionForm>();
  const { initDate } = watch();

  const startDateLimits = useMemo(() => {
    return dayjs(initDate).add(1, 'day').toDate();
  }, [initDate]);

  return (
    <>
      <Row className="pb-3">
        <Col xs={12} md={4}>
          <TextInput
            name="sessionName"
            label={texts.form.sessionName}
            control={control}
            rules={{ required: msgValidations.required }}
          />
        </Col>
        <Col xs={12} md={4}>
          <Select
            name="school"
            label={texts.form.school}
            options={schoolOptions}
            control={control}
            rules={{ required: msgValidations.required }}
            disabled={disabled}
          />
        </Col>
        <Col xs={12} md={4}>
          <Select
            name="year"
            label={texts.form.year}
            options={yearsOptions}
            control={control}
            rules={{ required: msgValidations.required }}
            disabled={disabled}
          />
        </Col>
        <Col xs={12} md={4}>
          <Select
            name="period"
            label={texts.form.period}
            options={periodOptions}
            control={control}
            rules={{ required: msgValidations.required }}
            disabled={disabled}
          />
        </Col>
        <Col md="4" sm="12">
          <DateInput
            name="sessionDate"
            label={texts.form.sessionDate}
            control={control}
            rules={{
              required: msgValidations.required,
            }}
          />
        </Col>
        <Col md="4" sm="12">
          <DateInput
            name="initDate"
            label={texts.form.initDate}
            control={control}
            rules={{
              required: msgValidations.required,
            }}
            disabled={disabled}
          />
        </Col>
        <Col md="4" sm="12">
          <DateInput
            name="endDate"
            label={texts.form.endDate}
            control={control}
            minDate={startDateLimits}
            rules={{
              required: msgValidations.required,
            }}
            disabled={disabled}
          />
        </Col>
      </Row>
      <Row className="pb-4" style={{ gap: '1rem' }}>
        <Col xs={12} md={12}>
          <TextAreaInput
            name="description"
            label={texts.form.description}
            control={control}
            height={100}
            rules={{
              required: msgValidations.required,
            }}
          />
        </Col>
      </Row>

      <RemoteSearchField />
    </>
  );
};

export default FormFields;
